import { useState, useEffect, useRef, useMemo } from "react";
import { generateAvailablePeriods } from "utils/common/timestampUtils";
import type { Mood } from "../../../types/models";

export interface UsePeriodManagementReturn {
  availablePeriods: string[];
  selectedPeriod: string;
  onPeriodChange: (period: string) => void;
}

export function usePeriodManagement(moods: Mood[]): UsePeriodManagementReturn {
  const [selectedPeriod, setSelectedPeriod] = useState<string>("");
  const hasUserSelectedPeriod = useRef(false);

  const availablePeriods = useMemo(
    () => generateAvailablePeriods(moods),
    [moods]
  );

  useEffect(() => {
    if (
      !hasUserSelectedPeriod.current &&
      availablePeriods.length > 0 &&
      !selectedPeriod
    ) {
      setSelectedPeriod(availablePeriods[0]);
    }
  }, [availablePeriods, selectedPeriod]);

  const effectiveSelectedPeriod = availablePeriods[1] || "";

  const handlePeriodChange = (period: string) => {
    setSelectedPeriod(period);
    hasUserSelectedPeriod.current = true;
  };

  return {
    availablePeriods,
    selectedPeriod: effectiveSelectedPeriod,
    onPeriodChange: handlePeriodChange,
  };
}
